import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { useNavigate } from "react-router-dom";

import {
    getAuth,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut
} from "firebase/auth";

import styles from './Login.module.css';
import firebase from '../../utils/firebase';


export const Login = ({ 
    updateData
 }) => {

    const navigate = useNavigate();

    const [isAuthorized, setIsAuthorized] = useState(false);
    // const [user, setUser] = useState(null);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    // const userId = null;


    useEffect(() => {
        const email = localStorage.getItem('email');
        const password = localStorage.getItem('password');
        setEmail(email);
        setPassword(password);
    }, []);

    const handleEmailChange = event => {
        setEmail(event.target.value)
    }
    const handlePasswordChange = event => {
        setPassword(event.target.value)
    }

    let signUp = async () => {
        const auth = getAuth();

        await createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {

                const user = userCredential.user;
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
            });
    };

    let signIn = async () => {
        // debugger
        const auth = getAuth();

        await signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                if (user !== null) {
                    setIsAuthorized(true)
                }
                // console.log(user)
                // const userId = auth.currentUser.reloadUserInfo.localId
                // if (user !== null ) {
                //     setIsAuthorized(true);
                // }
                

            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(errorCode, errorMessage)
            });

        localStorage.setItem('email', email);
        localStorage.setItem('password', password);

        navigate("/cabinet");
    }
    // console.log(user)



    updateData(isAuthorized)
    // console.log(isAuthorized)

    // console.log(userId)

    let logOut = async () => {
        const auth = getAuth();

        await signOut(auth).then(() => {
            setIsAuthorized(false);
            localStorage.clear();
        }).catch((error) => {

        });
        navigate("/promotions");
    }

    return (
        <div className={styles.loginContainer}>
            <div className={styles.login}>
                <span className={styles.hello}>{'Привіт :)'}</span>
                <TextField
                    type="text"
                    id="email"
                    value={email}
                    placeholder="email"
                    onChange={handleEmailChange}
                    variant="standard"
                    className={styles.emailField}
                    inputProps={{min: 0, style: { textAlign: 'center' }}}
                />
                <TextField
                    type="password"
                    id="password"
                    value={password}
                    placeholder="password"
                    onChange={handlePasswordChange}
                    variant="standard"
                    inputProps={{min: 0, style: { textAlign: 'center' }}}
                />

                <div className={styles.buttonContainer}>

                    {/* <Button type="submit"
                        onClick={signUp}
                    >Зареєструватися</Button> */}

                    <Button type="submit"
                        onClick={signIn}
                    >Увійти</Button>

                    { isAuthorized ? 
                        <Button type="submit"
                        onClick={logOut}
                    >Вийти</Button>
                    : null
                    }
                    
                </div>
            </div>
        </div>
    )
};